// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2f822dd7","455":"59aba6ff","578":"4ac804a5","977":"4dc61a07"}[chunkId] + ".chunk.js";
};